import _ from "lodash";
import { Dispatch } from "redux";
import { refresh } from "@/config";

interface APICall {
  apiName: string;
  args?: any[];
  data?: any;
  headers?: Record<string, string>;
  method?: "GET" | "POST" | "PUT" | "PATCH" | "DELETE";
  forceCall?: boolean;
}

interface APICallAction {
  type: "API_CALL";
  apiName: string;
  args?: any[];
  data?: any;
  headers?: Record<string, string>;
  method: "GET" | "POST" | "PUT" | "PATCH" | "DELETE";
  forceCall?: boolean;
}

export function dispatchAPICall(dispatch: Dispatch, call: APICall): APICallAction {
  return dispatch({
    type: "API_CALL",
    apiName: call.apiName,
    args: call.args,
    data: call.data,
    headers: call.headers,
    method: call.method || "GET",
    forceCall: call.forceCall,
  }) as APICallAction;
}

export function dispatchAPICalls(dispatch: Dispatch, calls: APICall[]): void {
  _.forEach(calls, (call: APICall) => dispatchAPICall(dispatch, call));
}

/**
 * Dispatchs calls every `refreshInterval || refresh.default`
 */
export function refreshAPICalls(
  dispatch: Dispatch,
  calls: APICall[],
  refreshInterval?: number,
  skipFirst: boolean = false
): () => void {
  if (!skipFirst) {
    dispatchAPICalls(dispatch, calls);
  }
  const interval = setInterval(() => dispatchAPICalls(dispatch, calls), refreshInterval || refresh.default);
  return () => clearInterval(interval);
}
